import React from "react";
import { Button, Card, Col, Form, Input, Row } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import i18n from "../../../../translations/i18n";

const CustomTabsField = () => {
  const { t } = useTranslation();

  return (
    <Card title={t("custom_tabs")}>
      <Form.List name="customTabs">
        {(fields, { add, remove }) => {
          return (
            <div className="m-3">
              {fields.map((field, index) => (
                <Card
                  key={field.key}
                  size="small"
                  title={`${t("tab")} ${index + 1}`}
                  extra={
                    <MinusCircleOutlined
                      onClick={() => remove(field.name)}
                      style={{ color: "red", cursor: "pointer" }}
                    />
                  }
                  style={{ marginBottom: 16 }}
                >
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        {...field}
                        label={t("tab_title")}
                        name={[field.name, "title"]}
                        rules={[
                          {
                            required: true,
                            message: i18n.t("form.enter_tab_title"),
                          },
                        ]}
                      >
                        <Input placeholder={t("form.enter_tab_title")} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        {...field}
                        label={t("tab_content")}
                        name={[field.name, "content"]}
                        rules={[
                          {
                            required: true,
                            message: i18n.t("form.enter_tab_content"),
                          },
                        ]}
                      >
                        <Input.TextArea
                          rows={6}
                          placeholder={t("form.enter_tab_content")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  {t("add_custom_tab")}
                </Button>
              </Form.Item>
            </div>
          );
        }}
      </Form.List>
    </Card>
  );
};

export default CustomTabsField;
